import { render } from "./DataExports.vue?vue&type=template&id=92665b3c&scoped=true"
import script from "./DataExports.vue?vue&type=script&lang=js"
export * from "./DataExports.vue?vue&type=script&lang=js"

import "./DataExports.vue?vue&type=style&index=0&id=92665b3c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-92665b3c"]])

export default __exports__